import { useState, useEffect, useLayoutEffect } from 'react';

export default function useDropdownTriggerCoords(
  isVisible,
  setIsVisible,
  triggerRef
) {
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!triggerRef.current) {
      return;
    }

    if (isVisible) {
      const rect = triggerRef.current.getBoundingClientRect();

      setCoords({
        x: rect.left,
        y: rect.top,
      });

      setWidth(rect.width);
      setHeight(rect.height);
    } else {
      setCoords({ x: 0, y: 0 });
      setWidth(0);
      setHeight(0);
    }
  }, [isVisible, triggerRef]);

  useEffect(() => {
    const hide = () => {
      setIsVisible(false);
    };

    window.addEventListener('resize', hide);

    return () => {
      window.removeEventListener('resize', hide);
    };
  }, [setIsVisible]);

  return { coords, triggerWidth: width, triggerHeight: height };
}
